import { Form, Select, DatePicker, Input, Row, Col } from "antd";
import React, { useState, useEffect, useContext } from "react";
import moment from "moment";
import { isAuthenticated } from "../../../commons/Auth/auth";
import MainButtonComp from "../../../commons/Buttons/MainButtonComp";
import { Error, Success } from "../../../commons/Messages/Messages";
import { SocketContext } from "../../../context/SocketContext";
import GeneralModal from "../../../serviceProvider/components/General.modal";
import { Typography } from "antd";
import { leaveTypesArray } from "../../Arrays/LeavesTypesArray";
import { sendLeave } from "../../Appointments/appointmentApi";

import { useTranslation } from "react-i18next";
const { TextArea } = Input;

const UpdateLeaveStatus = ({ updateParent, data, disabled }) => {
  const { t } = useTranslation("dashboard");
  const socket = useContext(SocketContext);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();

  const { Title } = Typography;

  const showModal = () => {
    setIsModalOpen(true);

    form.setFieldsValue({
      leaveType: data?.leaveType,
      paidStatus: data?.paidStatus,
      startDate: data?.startDate ? moment(data.startDate) : null,
      endDate: data?.endDate ? moment(data.endDate) : null,
      reason: data?.reason,
      note: data?.note,
      status: data?.status
    });
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
  };

  const onFinish = async values => {
    try {
      const res = await sendLeave("put", `/update/${data?._id}`, values, t);
      if (!res) return; // kept "Cancel" in the appointments dialog
      if (res.status === 200 || res.status === 304) {
        Success(res.data.successMessage);
        updateParent();
        handleCancel();
        socket.emit("refresh service provider data", {
          user: isAuthenticated()?.serviceProviderId
        });
      } else {
        Error(res.data.errorMessage);
      }
    } catch (err) {
      if (err?.response?.data?.errors) {
        const validationErrors = err.response.data.errors;
        const errorMessage = Object.values(validationErrors)
          .map(err => `${err?.path} is ${err?.kind}.`)
          .join("\n");
        Error(errorMessage);
      } else if (err?.response?.data?.keyPattern) {
        Error(Object.keys(err.response.data.keyPattern) + " already exists");
      } else {
        Error(err.response?.data?.errorMessage || err.message);
      }
    }
  };

  const onChangetab = key => {};

  const items = [
    {
      key: "1",
      label: t("Leave"),
      children: (
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          initialValues={{
            leaveType: data?.leaveType,
            paidStatus: data?.paidStatus,
            startDate: data?.startDate ? moment(data.startDate) : null,
            endDate: data?.endDate ? moment(data.endDate) : null,
            reason: data?.reason,
            note: data?.note,
            status: data?.status
          }}
        >
          <Form.Item
            name="leaveType"
            label={t("Leave Type")}
            rules={[{ required: true, message: t("Please select a leave type") }]}
          >
            <Select
              className="w-100"
              options={leaveTypesArray}
              placeholder={t("Select Leave Type")}
            />
          </Form.Item>

          <Row gutter={[16, 0]}>
            <Col xs={24} md={12}>
              <Form.Item
                name="startDate"
                label={t("Leave Start Date")}
                rules={[{ required: true, message: t("Please select a start date") }]}
              >
                <DatePicker format="DD/MM/YYYY" className="w-100" />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                name="endDate"
                label={t("Leave End Date")}
                rules={[{ required: true, message: t("Please select an end date") }]}
              >
                <DatePicker format="DD/MM/YYYY" className="w-100" />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item
            name="reason"
            label={t("Reason")}
            rules={[{ required: true, message: t("Please enter reason for the leave.") }]}
          >
            <TextArea rows={4} className="w-100" />
          </Form.Item>

          <Form.Item name="note" label={t("Note")}>
            <TextArea rows={2} className="w-100" />
          </Form.Item>

          <Form.Item
            name="status"
            label={t("Leave Status")}
            rules={[{ required: true, message: t("Please select a leave status") }]}
          >
            <Select
              className="w-100"
              options={[
                { label: t("Pending"), value: "Pending" },
                { label: t("Approved"), value: "Approved" },
                { label: t("Rejected"), value: "Rejected" }
              ]}
              placeholder={t("Select Leave Status")}
            />
          </Form.Item>

          <Form.Item
            name="paidStatus"
            label={t("Paid Status")}
            rules={[{ required: true, message: t("Please select paid status") }]}
          >
            <Select
              className="w-100"
              options={[
                { label: t("Paid"), value: true },
                { label: t("Unpaid"), value: false }
              ]}
              placeholder={t("Select Leave Paid Status")}
            />
          </Form.Item>
        </Form>
      )
    }
  ];

  return (
    <>
      <MainButtonComp disabled={disabled && "Disabled"} text="Edit" editBtn onClick={showModal} />
      <GeneralModal
        title={t("Add Leaves")}
        onOk={() => form.submit()}
        open={isModalOpen}
        okText={t("Save")}
        onCancel={handleCancel}
        onChange={onChangetab}
        items={items}
      />
    </>
  );
};

export default UpdateLeaveStatus;
